<template>
    <div>
        <Header :data_status="data_status"></Header>
        <div>
            <div class="card-block" v-show="data_status != 'loading'">
                <div class="inline" justify="between" valign="center">
                    <h1>Кейс #{{ $route.params.id }} - {{ data.title }}<router-link class="button _free _second" to="/email_case">К списку</router-link></h1>
                </div>
                <form class="card" v-if="data.parts">
                    <h3>Заголовки:</h3>

                    <div class="form-item text-item" v-if="subject.add" :status="subject.status">
                        <div class="inline" valign="bottom">
                            <div class="grid">
                                <label for="langen">En</label>
                                <div class="inline">
                                    <input type="text" id="langen" class="text-input" v-model="subject.en" />
                                    <div class="hbutton _hide"></div>
                                </div>
                            </div>
                            <div class="grid">
                                <label for="langes">Es</label>
                                <div class="inline">
                                    <input type="text" id="langes" class="text-input" v-model="subject.es" />
                                    <div class="hbutton _hide"></div>
                                </div>
                            </div>
                            <div class="grid">
                                <div v-if="subject.en || subject.es" class="button _free _accept" @click="add('subject')">Добавить</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-item text-item" v-else>
                        <div class="button _free _second _add" @click="subject.add = true">Добавить</div>
                    </div>

                    <div class="form-item text-item" v-for="(subject, key) in data.parts.subject.slice().reverse()" :key="'s'+key">
                        <div class="inline" valign="bottom">
                            <div class="grid">
                                <label :for="'langen'+key">En</label>
                                <div class="inline">
                                    <input type="text" :id="'langen'+key" class="text-input" v-model="subject.content.en" />
                                    <div class="hbutton _refresh" :class="{_disabled: hasNoChange('subject', key, 'en')}" @click="updateField('en', subject)"></div>
                                </div>
                            </div>
                            <div class="grid">
                                <label :for="'langes'+key">Es</label>
                                <div class="inline">
                                    <input type="text" :id="'langes'+key" class="text-input" v-model="subject.content.es" />
                                    <div class="hbutton _refresh" :class="{_disabled: hasNoChange('subject', key, 'es')}" @click="updateField('es', subject)"></div>
                                </div>
                            </div>
                            <div class="grid">
                                <div class="button _free _decline" @click="remove(subject)">Удалить</div>
                            </div>
                        </div>
                    </div>

                    <h3>Шапка:</h3>
                    <div class="form-item text-item" v-for="(header, key) in data.parts.header.slice().reverse()" :key="'h'+key">
                        <div class="inline" valign="bottom">
                            <div class="grid">
                                <label :for="'helangen'+key">En</label>
                                <div class="inline">
                                    <input type="text" :id="'helangen'+key" class="text-input" v-model="header.content.en" />
                                    <div class="hbutton _refresh" :class="{_disabled: hasNoChange('header', key, 'en')}" @click="updateField('en', header)"></div>
                                </div>
                            </div>
                            <div class="grid">
                                <label :for="'helanges'+key">Es</label>
                                <div class="inline">
                                    <input type="text" :id="'helanges'+key" class="text-input" v-model="header.content.es" />
                                    <div class="hbutton _refresh" :class="{_disabled: hasNoChange('header', key, 'es')}" @click="updateField('es', header)"></div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <h3>Сообщение:</h3>

                    <div class="form-item text-item" v-if="body.add" :status="body.status">
                        <div class="inline" valign="bottom">
                            <div class="grid">
                                <label for="blangen">En</label>
                                <div class="inline">
                                    <textarea id="blangen" v-model="body.en"></textarea>
                                    <div class="hbutton _hide"></div>
                                </div>
                            </div>
                            <div class="grid">
                                <label for="blanges">Es</label>
                                <div class="inline">
                                    <textarea id="blanges" v-model="body.es"></textarea>
                                    <div class="hbutton _hide"></div>
                                </div>
                            </div>
                            <div class="grid">
                                <div v-if="body.en || body.es" class="button _free _accept" @click="add('body')">Добавить</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-item text-item" v-else>
                        <div class="button _free _second _add" @click="body.add = true">Добавить</div>
                    </div>

                    <div class="form-item text-item" v-for="(item, key) in data.parts.body.slice().reverse()" :key="'b'+key">
                        <div class="inline" valign="bottom">
                            <div class="grid">
                                <label :for="'blangen'+key">En</label>
                                <div class="inline" valign="bottom">
                                    <textarea :id="'blangen'+key" v-model="item.content.en"></textarea>
                                    <div class="hbutton _refresh" :class="{_disabled: hasNoChange('body', key, 'en')}" @click="updateField('en', item)"></div>
                                </div>
                            </div>
                            <div class="grid">
                                <label :for="'blanges'+key">Es</label>
                                <div class="inline" valign="bottom">
                                    <textarea :id="'blanges'+key" v-model="item.content.es"></textarea>
                                    <div class="hbutton _refresh" :class="{_disabled: hasNoChange('body', key, 'es')}" @click="updateField('es', item)"></div>
                                </div>
                            </div>
                            <div class="grid">
                                <div class="button _free _decline" @click="remove(item)">Удалить</div>
                            </div>
                        </div>
                    </div>

                    <h3>Подвал:</h3>
                    <div class="form-item text-item" v-for="(footer, key) in data.parts.footer.slice().reverse()" :key="'f'+key">
                        <div class="inline" valign="bottom">
                            <div class="grid">
                                <label :for="'flangen'+key">En</label>
                                <div class="inline">
                                    <input type="text" :id="'flangen'+key" class="text-input" v-model="footer.content.en" />
                                    <div class="hbutton _refresh" :class="{_disabled: hasNoChange('footer', key, 'en')}" @click="updateField('en', footer)"></div>
                                </div>
                            </div>
                            <div class="grid">
                                <label :for="'flanges'+key">Es</label>
                                <div class="inline">
                                    <input type="text" :id="'flanges'+key" class="text-input" v-model="footer.content.es" />
                                    <div class="hbutton _refresh" :class="{_disabled: hasNoChange('footer', key, 'es')}" @click="updateField('es', footer)"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="page-load" v-show="data_status == 'loading'">
                <div class="inline" valign="center">
                    <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'

    export default {
        components: {
            Header
        },
        data () {
            return {
                data: {},
                data_backup: false,
                data_status: 'init',
                subject: {
                    add: false,
                    en: '',
                    es: '',
                    status: ''
                },
                body: {
                    add: false,
                    en: '',
                    es: '',
                    status: ''
                }
            }
        },
        created () {
            this.getData()
        },
        methods: {
            remove (item) {
                this.axios.delete('api/admin/v2/email_case/' + this.$route.params.id + '/part/' + item.id)
                    .then(resp => {
                        this.data = resp.data.response
                        this.savedata()
                        let msg = {
                            message: 'Данные удалены',
                            status: 'success'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                    })
                    .catch(() => {
                        let msg = {
                            message: 'Ошибка при удалении данных',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                    })
            },
            add (type) {
                let type_num = 1
                if (type == 'body') {
                    type_num = 3
                }
                let json = JSON.stringify({
                    "type": type_num,
                    "content": {
                        "en": this[type].en,
                        "es": this[type].es
                    }
                })
                this[type].status = 'loading'
                this.axios.post('api/admin/v2/email_case/' + this.$route.params.id + '/part', json, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(resp => {
                    this[type].add = false
                    this[type].en = ''
                    this[type].es = ''
                    this[type].status = ''

                    this.data = resp.data.response

                    this.savedata()
                    let msg = {
                        message: 'Данные добавлены',
                        status: 'success'
                    }
                    this.$store.dispatch('utils/showMessage', msg)
                }).catch(() => {
                    this[type].status = ''
                    let msg = {
                        message: 'Ошибка при добавлении данных',
                        status: 'error'
                    }
                    this.$store.dispatch('utils/showMessage', msg)
                })
            },
            updateField (lang, data) {
                let json = JSON.stringify({
                    "lang": lang,
                    "content": data.content[lang]
                })
                this.axios.post('api/admin/v2/email_case/' + this.$route.params.id + '/part/' + data.id, json, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(() => {
                    this.savedata()
                    let msg = {
                        message: 'Данные обновлены',
                        status: 'success'
                    }
                    this.$store.dispatch('utils/showMessage', msg)
                }).catch(() => {
                    let msg = {
                        message: 'Ошибка при обновлении данных',
                        status: 'error'
                    }
                    this.$store.dispatch('utils/showMessage', msg)
                })
            },
            hasNoChange (type, key, lang) {
                if (this.data.parts[type][key].content[lang] === this.data_backup.parts[type][key].content[lang]) return true
                return false
            },
            savedata () {
                this.data_backup = JSON.parse(JSON.stringify(this.data))
            },
            getData () {
                return new Promise((resolve) => {
                    this.data_status = 'loading'
                    this.axios.get('api/admin/v2/email_case/' + this.$route.params.id)
                        .then(resp => {
                            this.data = resp.data.response
                            this.savedata()
                            this.data_status = ''
                            resolve()
                        })
                        .catch(() => {
                            this.$router.push('/email_case')
                        })
                })
            }
        }
    }
</script>
